import React from 'react';
export function Hero() {
  return <section id="hero" className="relative overflow-hidden bg-white" data-id="element-67">
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-b from-blue-50/50 via-white to-white" data-id="element-68"></div>
      <div className="relative py-20 sm:py-28" data-id="element-69">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-70">
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900" data-id="element-71">
            Build Intelligent, Autonomous, <br className="hidden md:block" data-id="element-72" />
            <span className="text-blue-600" data-id="element-73">ROI-Ready Systems</span>
          </h1>
          <p className="mt-6 text-lg md:text-xl leading-8 text-slate-600 max-w-3xl mx-auto" data-id="element-74">
            We design AI that learns, adapts, and compounds value—from embedded
            copilots inside your apps to autonomous agents that execute
            end-to-end workflows.
          </p>
          <p className="mt-4 text-xl md:text-2xl font-semibold text-slate-900" data-id="element-75">
            Result: smarter decisions, faster operations, and measurable
            business impact.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4" data-id="element-76">
            <a href="#start" className="bg-blue-600 text-white hover:bg-blue-700 px-8 py-3 rounded-lg text-lg font-semibold shadow-lg transition-colors" data-id="element-77">
              Get Started
            </a>
            <a href="#services" className="bg-white text-blue-600 hover:bg-slate-50 px-8 py-3 rounded-lg text-lg font-semibold shadow-lg border-2 border-slate-200 transition-colors" data-id="element-78">
              Explore Services
            </a>
          </div>
        </div>
      </div>
    </section>;
}